import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AnonymousLockDirective } from './anonymous-lock.directive';
import { CarouselSwipeDirective } from './carousel-swipe.directive';
import { DebounceDirective } from './debounce.directive';
import { FixedTableHeaderDirective } from './fixed-table-header.directive';
import { OnvisibleDirective } from './onvisible.directive';
import { PerfectScrollbarDirective } from './perfect-scrollbar.directive';
import { PopoverDirective } from './popover.directive';
import { ProgressCircleChartDirective } from './progress-circle-chart/progress-circle-chart.directive';
import { ProgressCircleDirective } from './progress-circle-chart/progress-circle.directive';
import { ScrollbarHintDirective } from './scrollbar-hint.directive';
import { StorePermissionDirective } from './store-permission.directive';
import { TooltipDirective } from './tooltip.directive';
import { ClickOutsideDirective } from './click-outside.directive';

@NgModule({
  imports: [FormsModule],
  declarations: [
    AnonymousLockDirective,
    CarouselSwipeDirective,
    DebounceDirective,
    FixedTableHeaderDirective,
    OnvisibleDirective,
    PerfectScrollbarDirective,
    PopoverDirective,
    ProgressCircleChartDirective,
    ProgressCircleDirective,
    ScrollbarHintDirective,
    StorePermissionDirective,
    TooltipDirective,
    ClickOutsideDirective
  ],
  exports: [
    AnonymousLockDirective,
    CarouselSwipeDirective,
    DebounceDirective,
    FixedTableHeaderDirective,
    OnvisibleDirective,
    PerfectScrollbarDirective,
    PopoverDirective,
    ProgressCircleChartDirective,
    ProgressCircleDirective,
    ScrollbarHintDirective,
    StorePermissionDirective,
    TooltipDirective,
    ClickOutsideDirective
  ]
})
export class DirectivesModule {}
